import React from "react";
import api from "utils/api";
import "./Others.scss";
import Loader from "Components/Loader";
import DOTSNewSummaryChild from "./DOTSNewSummaryChild";
import { Empty, message } from "antd";
import { CONSTANTS } from "utils/constant";

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resultObjects: [],
    };
  }

  componentDidMount() {
    this.getDOTStAnswerDetails();
  }

  getDOTStAnswerDetails() {
    this.setState({ isLoading: true });
    api
      .get_dots_answer_list({
        patient_id: this.props.data?.patient_id,
        type: this.props.data?.user_type,
      })
      .then((res) => {
        this.setState({ isLoading: false });
        if(res.data.status == "200"){
        this.setState({          
          resultObjects: res.data?.data?.results,        
        });
        }else{
          this.setState({          
            resultObjects: [],        
          });
        }
      })
      .catch((err) => {
        message.error(`${CONSTANTS.SOMETHING_WENT_WRONG}`, ErrorDuration);
        this.setState({ isLoading: false });
      });
  }

  render() {
    return (
      <>
        {this.state.isLoading ? (
          <Loader />
        ) : (
          <div className="mhe-wrapper-container">
            <div className="mhe-header">
              <div>{CONSTANTS.DOTS}</div>
            </div>

            <div className="mhe-content">
              {this.state.resultObjects.length == 0 ? (
                <Empty
                  description={CONSTANTS.NO_DATA}
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              ) : (
                (this.state.resultObjects || []).map((data, index) => {
                  return (
                    <React.Fragment key={index}>
                      {data.is_completed ? (
                        <DOTSNewSummaryChild data={data} />
                      ) : null}
                    </React.Fragment>
                  );
                })
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}
